<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-input placeholder="请输入部门名称" class="a_input_self margin_self" v-model="queryParam.deptName" @keyup.enter.native="fetch" />
      <a-select placeholder="请选择状态" class="a_input_self margin_self" v-model="queryParam.status" @keyup.enter.native="fetch">
        <a-select-option value="">全部</a-select-option>
        <a-select-option value="0">正常</a-select-option>
        <a-select-option value="1">停用</a-select-option>
      </a-select>
      <a-button type="primary" @click="this.fetch">查询</a-button>
      <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
      <a-button v-if="addEnable" type="primary" icon="plus" @click="$refs.modal.add()">新建</a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        ref="table"
        rowKey="deptId"
        :pagination="pagination"
        :loading="loading"
        :columns="columns"
        :dataSource="data"
        :scroll="{ y: scroll_y }"
      >
        <span slot="menuType" slot-scope="text">
          {{ text | menuTypeFilter }}
        </span>

        <span slot="status" slot-scope="text" :style="{ color: text=='0' ? 'green' : 'red' }">
          {{ text | statusFilter }}
        </span>

        <span slot="action" slot-scope="text, record">
          <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-if="addEnable" @click="handleAdd(record.deptId + '')">新增</a>
        </span>
      </a-table>
    </div>

    <dept-modal ref="modal" @ok="handleOk" />
  </div>
</template>

<script>
import { Table as T } from 'ant-design-vue'
import { getDeptList, delDept } from '@/api/system'
import DeptModal from './modules/DeptModal.vue'
import { treeData } from '@/utils/treeutil'
import { checkPermission } from '@/utils/permissions'
export default {
  name: 'TableList',
  components: {
    T,
    DeptModal,
  },
  data() {
    return {
      description:
        '列表使用场景：后台管理中的权限管理以及角色管理，可用于基于 RBAC 设计的角色权限控制，颗粒度细到每一个操作类型。',

      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      form: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '权限名称',
          dataIndex: 'deptName',
        },
        {
          title: '排序',
          dataIndex: 'orderNum',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
        },
        {
          title: '操作',
          width: '150px',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
      ],
      data: [],
      pagination: false,
      loading: false,
      addEnable: checkPermission('system:dept:add'),
      editEnabel: checkPermission('system:dept:edit'),
      removeEnable: checkPermission('system:dept:remove'),
    }
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        1: '停用',
        0: '正常',
      }
      return statusMap[status]
    },
    menuTypeFilter(type) {
      const menuMap = {
        M: '目录',
        F: '按钮',
        C: '菜单',
      }
      return menuMap[type]
    },
  },
  created() {
    this.fetch()
  },
  mounted() {
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height()
        this.$forceUpdate()
      }, 1000)
    })
  },
  methods: {
    handleAdd(parentId) {
      console.log(parentId)
      this.$refs.modal.add(parentId)
    },
    handleEdit(record) {
      this.$refs.modal.edit(record)
    },
    handleOk() {
      this.fetch()
    },
    buildtree(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            deptId: item.deptId, // value是给modal的select用的，2者属性不一样
            deptName: item.deptName,
            orderNum: item.orderNum,
            status: item.orderNum,
            createTime: item.createTime,
            parentId: item.parentId,
            isCompany: item.isCompany,
            status:item.status,
            leader:item.leader,
            leaderDept:item.leaderDept,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    fetch() {
      this.data=[];
      this.loading = true
      getDeptList(Object.assign(this.queryParam)).then((res) => {
        const data = res.rows
        if (data.length > 0) {
          const min = Math.min(...data.map((m) => m.parentId))
          this.buildtree(data, this.data, min)
          console.log(this.data)
        }
        this.loading = false
      })
    },
  },
  watch: {
    /*
      'selectedRows': function (selectedRows) {
        this.needTotalList = this.needTotalList.map(item => {
          return {
            ...item,
            total: selectedRows.reduce( (sum, val) => {
              return sum + val[item.dataIndex]
            }, 0)
          }
        })
      }
      */
  },
}
</script>
